// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__vcNDC","pageItem":"Pagination_pageItem__JqCQg","active":"Pagination_active__DDld0"};